export const MAX_MENU_LVL = 3;

export interface MenuItem {
    key: string,
    name: string,
    level: number,
    link?: string,
    cqlEnabled?: boolean,
    cqlString?: string,
    openInNewTab?: boolean,
    pageId?: string,
    spaceKey?: string,
    subMenuItems?: Array<MenuItem>,
    imageUrl?: string,
    imageStorageName?: string,
    icon?: string
}

export interface Menu {
    key: string,
    name: string,
    default: boolean,
    active?: boolean,
    primaryColor: string,
    subMenuBgColor: string,
    primaryColorDarkTheme?: string,
    subMenuBgColorDarkTheme?: string,
    menuItems: Array<MenuItem>,
    userGroups?: Array<string>,
    anonymousAccess?: boolean,
    spaceLabels?: Array<string>
}

export interface UserPreference {
    firstConfigureDone: boolean;
    firstOverviewDone: boolean;
    hideReviewBanner: boolean;
}

export interface EditorGroups {
    groupIds: Array<string>
}

export type StorageFileResult = {
    downloadUrl: string;
    imageStorageName: string;
};

export type FileUploadContext = "menuitemimg";

export const DEFAULT_MENU_VALUES = {
    "primaryColor": "#ffffff",
    "subMenuBgColor": "#f4f5f7",
    "primaryColorDarkTheme": "#1D2125",
    "subMenuBgColorDarkTheme": "#282E33",
    "active": false,
};

export const BASE_MENU_CONFIG = {
    ...DEFAULT_MENU_VALUES,
    "name": "Menu name",
    "menuItems": [{"level": 1, "name": "Your first menu item", "key": "1.0.0"}]
};

export const DEMO_MENU_CONFIG = {
    "default": true,
    "active": false,
    "name": "Demo menu",
    "primaryColor": "#ffffff",
    "subMenuBgColor": "#f4f5f7",
    "primaryColorDarkTheme": "#1D2125",
    "subMenuBgColorDarkTheme": "#282E33",
    "menuItems": [{
        "level": 1,
        "icon": "globe",
        "subMenuItems": [{
            "level": 2,
            "subMenuItems": [{"level": 3, "name": "Link 1", "key": "1.1.1"}, {"level": 3, "name": "Link 2", "key": "1.1.2"}, {
                "level": 3,
                "name": "Link 3",
                "key": "1.1.3"
            }, {"level": 3, "name": "Link 4", "key": "1.1.4"}],
            "name": "Sub menu 1",
            "key": "1.1.0",
            "imageUrl": "https://cdn.pixabay.com/photo/2019/04/26/07/12/notes-4156924_960_720.png"
        }, {
            "level": 2,
            "name": "Sub menu 2",
            "key": "1.2.0",
            "imageUrl": "https://cdn.pixabay.com/photo/2020/04/04/04/22/analysis-5000776_960_720.png"
        }, {
            "level": 2,
            "name": "Sub menu 3",
            "key": "1.3.0",
            "imageUrl": "https://cdn.pixabay.com/photo/2019/04/26/18/19/computer-4158213_960_720.png"
        },
            {"level": 2, "name": "Sub menu 4", "key": "1.4.0", "imageUrl": "https://cdn.pixabay.com/photo/2019/04/29/16/10/connection-4166469_960_720.png"}],
        "name": "Menu 1",
        "key": "1.0.0",
        "imageUrl": "https://cdn.pixabay.com/photo/2014/03/22/17/00/the-background-292720__340.png"
    }, {"level": 1, "name": "Menu 2", "key": "2.0.0", "icon": "people-group"}, {"level": 1, "name": "Menu 3", "key": "3.0.0", "icon": "display"}, {
        "level": 1,
        "name": "Menu 4",
        "key": "4.0.0",
        "icon": "book-open"
    }, {
        "level": 1,
        "name": "External link",
        "key": "5.0.0",
        "openInNewTab": true,
        "link": "https://seibert.biz/cloud-navigation-documentation",
        "icon": "arrow-up-right-from-square"
    }]
};
